module.exports = __webpack_public_path__ + "img/FR18979.0a43a393.png";